var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"blank-container"},[_vm._m(0),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-header-container"},[_c('img',{staticClass:"logo-header",attrs:{"src":require("@/assets/buzzztv_logo.png"),"alt":"BuzzzTV"}})])
}]

export { render, staticRenderFns }